import { doc, getFirestore, updateDoc } from "firebase/firestore";
import { UserData } from "../User/UserData";
import { LocalData } from "../General/LocalData";
import { RelativeData } from "../General/RelativeData";
import { SubtaskFieldData } from "../Deviation/Subtask/SubtaskFieldData";
import { IRelatives } from "@propely/propely-typings";

export class RoutineTask {
  id: string;
  title: string = "";
  description: string = "";

  responsible: UserData[] = [];
  fields: SubtaskFieldData[] = [];
  fieldsOrder: string[] = [];

  relatives: Record<string, RelativeData> = {};
  rawRelatives: IRelatives = {};

  constructor(id: string) {
    this.id = id;
  }

  setup(data: any) {
    this.title = typeof data.title === "string" ? data.title : "";
    this.description = typeof data.description === "string" ? data.description : "";
    this.responsible = [];

    if (typeof data.responsible === "object") {
      this.responsible = Object.keys(data.responsible).map((uid) => LocalData.users.addData(uid));
    }

    // Fields
    this.fields = [];
    this.fieldsOrder = Array.isArray(data.fieldsOrder) ? data.fieldsOrder : [];
    if (typeof data.fields === "object") {
      for (const fieldID of Object.keys(data.fields)) {
        const field = data.fields[fieldID];
        const type = field.valueType;
        if (typeof type === "string" && ["number", "checkbox", "string", "selection"].includes(type)) {
          this.fields.push({
            id: fieldID,
            title: typeof field.title === "string" ? field.title : "",
            value: typeof field.value === type ? field.value : "",
            valueType: type as SubtaskFieldData["valueType"],
            unit: typeof field.unit === "string" ? field.unit : "",
            options: Array.isArray(field.options) ? field.options : [],
          });
        }
      }
    }

    this.relatives = {};
    if (typeof data.relatives === "object") {
      for (const relativeID of Object.keys(data.relatives)) {
        this.relatives[relativeID] = new RelativeData(relativeID, data.relatives[relativeID]);
        this.rawRelatives[relativeID] = data.relatives[relativeID];
      }
    }
  }

  toMap(): { [key: string]: any } {
    const responsibleMap: { [key: string]: any } = {};
    for (const responsible of this.responsible) responsibleMap[responsible.id] = {};

    return {
      title: this.title,
      description: this.description,
      responsible: responsibleMap,
    };
  }

  toggleResponsible(responsible: boolean, user: UserData, completion: (error?: Error) => void) {
    const db = getFirestore();
    let responsibleUsers: { [key: string]: any } = {};
    this.responsible.forEach((responsibleUser) => {
      if (responsibleUser !== user || (responsible === true && responsibleUser === user)) {
        responsibleUsers[responsibleUser.id] = {};
      }
    });
    if (!responsibleUsers[user.id] && responsible) {
      responsibleUsers[user.id] = {};
    }
    const routineDocRef = doc(db, "routines", this.id);
    updateDoc(routineDocRef, {
      responsible: responsibleUsers,
    })
      .then(() => {
        this.responsible = [];
        for (let userId in responsibleUsers) {
          let user = LocalData.users.addData(userId);
          this.responsible.push(user);
        }
        completion(undefined);
      })
      .catch((error: Error) => {
        completion(error);
      });
  }
}
